import { useState, useEffect } from "react";
import Navigation from "../Navigation";
import Header from "../Header";
import AddLessonForm from "../Forms/addLessonForm";
import Loading from "../loading";
import GetAdmin from "../../utils/getAdmin";
import NotFoundPage from "./404";
import LessonTable from "../tables/LessonTable";
import Notification from "../Notification";
import { getPaginatedLessons } from "../../api/lesson";

const Lesson = () => {
  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [lessonData, setLessonData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);
  const [showNotification, setShowNotification] = useState(false);
  const [status, setStatus] = useState();
  const [refresh, setRefresh] = useState(true);
  const [edit, setEdit] = useState(false);
  const [lessonId, setLessonId] = useState(null);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    grade: "",
    book: "",
  });

  // ✅ گرفتن اطلاعات مدیر فقط یک بار
  useEffect(() => {
    const loadAdmin = async () => {
      const admin = await GetAdmin();
      setAdminData(admin);
    };
    loadAdmin();
  }, []);

  const fetchLessons = async () => {
    try {
      setLoading(true);
      const params = {
        page,
        limit: 10,
        search,
        grade: filters.grade,
        book: filters.book,
      };

      const res = await getPaginatedLessons(params);
      setLessonData(res.lessons);
      setTotalPages(res.totalPages);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ هر وقت refresh یا page تغییر کرد دوباره بگیر
  useEffect(() => {
    fetchLessons();
  }, [page, refresh]);

  if (loading) return <Loading />;
  if (!adminData) return null;

  const notificationProps = (() => {
    switch (status) {
      case 201:
        return {
          message: "ساخت درس موفقیت‌آمیز بود",
          type: "success",
          duration: 3000,
        };
      case 200:
        return {
          message: edit
            ? "ویرایش درس موفقیت‌آمیز بود"
            : "حذف درس موفقیت‌آمیز بود",
          type: "success",
          duration: 3000,
        };
      case 500:
        return {
          message: "مشکل سرور. لطفاً بعداً امتحان کنید.",
          type: "error",
        };
      case 409:
        return { message: "درسی با همین اطلاعات وجود دارد", type: "error" };
      default:
        return null;
    }
  })();

  if (adminData.role === "manager" || adminData.role === "questionMaker") {
    return (
      <div className="w-full flex justify-center flex-col items-center">
        {showNotification && (
          <Notification
            {...notificationProps}
            setShowNotification={setShowNotification}
            showNotification={showNotification}
          />
        )}

        <Header adminName={adminData.name} />

        <div className="flex flex-col md:flex-row gap-6 justify-between w-full">
          <div className="w-full md:w-1/4 mb-6 lg:mb-0">
            <Navigation />
          </div>
          <AddLessonForm
            setStatus={setStatus}
            setShowNotification={setShowNotification}
            setRefresh={setRefresh}
            lessonData={lessonData}
            edit={edit}
            setEdit={setEdit}
            lessonId={lessonId}
          />
        </div>

        {/* ✅ فیلتر و جستجو */}
        <div className="w-full flex flex-col md:flex-row flex-wrap gap-4 items-center justify-between px-4 bg-white rounded-lg my-5 shadow-lg py-3">
          <input
            type="text"
            placeholder="جستجو براساس عنوان درس..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full md:w-1/3 px-3 py-2 text-sm rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#075B4A] focus:border-transparent outline-none"
          />

          <select
            value={filters.grade}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, grade: e.target.value }))
            }
            className="w-full md:w-1/4 px-3 py-2 text-sm rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#075B4A] focus:border-transparent outline-none"
          >
            <option value="">همه پایه‌ها</option>
            <option value="1">اول</option>
            <option value="2">دوم</option>
            <option value="3">سوم</option>
            <option value="4">چهارم</option>
            <option value="5">پنجم</option>
            <option value="6">ششم</option>
          </select>

          <select
            value={filters.book}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, book: e.target.value }))
            }
            className="w-full md:w-1/4 px-3 py-2 text-sm rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#075B4A] focus:border-transparent outline-none"
          >
            <option value="">همه کتاب‌ها</option>
            <option value="1">ریاضی</option>
            <option value="2">فارسی ونگارش</option>
            <option value="3">علوم</option>
            <option value="4">قرآن</option>
            <option value="5">املا</option>
            <option value="6">هدیه‌های آسمانی</option>
            <option value="7">مطالعات اجتماعی</option>
          </select>

          {/* 🔘 دکمه اعمال فیلتر */}
          <button
            onClick={() => {
              setPage(1);
              fetchLessons();
            }}
            className="bg-[#075B4A]  text-white px-5 py-2 rounded-lg hover:bg-[#06463a] transition-all"
          >
            <p className="text-md px-2">اعمال فیلتر</p>
          </button>
        </div>

        {/* جدول درس‌ها */}
        <LessonTable
          data={lessonData}
          setStatus={setStatus}
          setShowNotification={setShowNotification}
          setRefresh={setRefresh}
          setEdit={setEdit}
          setLessonId={setLessonId}
          adminRole={adminData.role}
        />

        {/* ✅ کنترل صفحات با طراحی واکنش‌گرا */}
        <div className="flex flex-wrap justify-center items-center gap-2 mt-6 mb-10 px-2">
          <button
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
            className={`px-4 py-2 rounded-lg border border-gray-300 transition-all 
              ${
                page === 1
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-white hover:bg-[#075B4A] hover:text-white"
              }
            `}
          >
            قبلی
          </button>

          <div className="flex flex-wrap justify-center items-center gap-2">
            {Array.from({ length: totalPages }, (_, i) => i + 1)
              .slice(Math.max(0, page - 3), Math.min(totalPages, page + 2))
              .map((num) => (
                <button
                  key={num}
                  onClick={() => setPage(num)}
                  className={`px-3 py-1.5 rounded-lg border ${
                    num === page
                      ? "bg-[#075B4A] text-white"
                      : "bg-white hover:bg-gray-100"
                  }`}
                >
                  {num}
                </button>
              ))}
          </div>

          <button
            disabled={page === totalPages}
            onClick={() => setPage((prev) => prev + 1)}
            className={`px-4 py-2 rounded-lg border border-gray-300 transition-all 
              ${
                page === totalPages
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-white hover:bg-[#075B4A] hover:text-white"
              }
            `}
          >
            بعدی
          </button>
        </div>
      </div>
    );
  }

  return <NotFoundPage />;
};

export default Lesson;
